import i18n from "@/i18n";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge conditional class names with Tailwind conflict resolution. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Format an RFC3339 timestamp for display; returns "—" for empty input. */
export function formatDateTime(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  // Follow the in-app language, not the browser OS locale alone.
  const locale = (i18n.resolvedLanguage || i18n.language || "en").startsWith("zh")
    ? "zh-CN"
    : "en-US";
  return date.toLocaleString(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

/** Format byte counts consistently on management tables. */
export function formatBytes(value?: number | null): string {
	if (value === null || value === undefined || !Number.isFinite(value)) return "—";
	if (value < 1024) return `${Math.round(value)} B`;
	const units = ["KB", "MB", "GB", "TB", "PB"];
	let amount = value;
	let unit = units[0];
	for (const candidate of units) {
		amount /= 1024;
		unit = candidate;
		if (amount < 1024 || candidate === units[units.length - 1]) break;
	}
	return `${amount.toFixed(amount >= 100 ? 0 : amount >= 10 ? 1 : 2)} ${unit}`;
}

export function usagePercent(used: number, quota?: number | null): number | null {
	if (quota === null || quota === undefined || quota <= 0) return null;
	return Math.max(0, Math.min(100, (used / quota) * 100));
}
